import { IonContent, IonIcon, IonPage, IonRouterLink, useIonRouter, useIonViewWillEnter } from '@ionic/react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Autoplay, Pagination, Navigation } from 'swiper'
import { useContext, useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { observer } from 'mobx-react'
import { StyleIonHeader, CustomSpacer, ProductCard, TextStyle, DetailContent, ParamOption } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { DivideLineBold } from '../../../components/atoms/divide'
import { cashSharp, timeSharp } from 'ionicons/icons'
import { amountString, onParams } from '../../../common'
import { CategoryTitle } from '../components'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

export const Main: React.FC<RouteComponentProps> = observer(() => {
  const { commonStore, homeStore, authStore } = useContext(StoresContext)
  const mainStore = homeStore.mainStore
  const categoryStore = homeStore.categoryStore
  const [categoryIds, setCategoryIds] = useState<number>(0)
  const router = useIonRouter()

  useIonViewWillEnter(() => {
    commonStore.setShowTab(true)
    mainStore.load(undefined, true)
    categoryStore.load(undefined, true)
    setCategoryIds(0)
    // FIXME : route 또는 store에서 통합 처리할 수 있도록 수정 필요
    setTimeout(() => {
      if (authStore.userInfo?.status === 'NEED_REQUIRE_DATA_INPUT') {
        router.push('/signUp')
      }
    }, 300)
  })

  useEffect(() => {
    onParams({
      store: categoryStore,
      categoryIds: categoryIds,
    })
  }, [categoryIds])

  const getRevenueRate = () => {
    const revenueRate = mainStore.content?.sellHistory?.revenueRate
    if (revenueRate == null) {
      return '-'
    }
    const revenueRateString = amountString(String(revenueRate), false, 2)
    return revenueRate > 0 ? `+ ${revenueRateString}%` : `${revenueRateString.replace('-', '- ')}%`
  }

  return (
    <IonPage>
      <StyleIonHeader title="MAIN" type={'MAIN'} rightItem={'ALARM'} />
      <IonContent>
        <DetailContent detailStore={mainStore}>
          <SSwiper
            centeredSlides={true}
            pagination={{ dynamicBullets: true, clickable: true }}
            navigation={true}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
            }}
            // loop={true}
            modules={[Autoplay, Pagination, Navigation]}
            observer={true}
            observeParents={true}
          >
            {mainStore.content?.banners.map((d, i) => (
              <SwiperSlide key={i}>
                <IonRouterLink routerLink={`/market/${d.id}`}>
                  <BannersContainer>
                    <img
                      src={d.imageUri}
                      alt={d.name}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null
                        currentTarget.src = '/img/thumbnail.svg'
                      }}
                    />
                    <div className="info">
                      <span className="artist">{d.artist}</span>
                      <span className="name">{d.name}</span>
                    </div>
                  </BannersContainer>
                </IonRouterLink>
              </SwiperSlide>
            ))}
          </SSwiper>
          <ParamOption
            categoryData={{
              categoryIds: categoryIds,
              setCategoryIds: setCategoryIds,
            }}
          />
          <CustomSpacer spacing="16px" />
          <CategoryTitle href={'/market'}>인기 거래 작품</CategoryTitle>
          <div style={{ height: '219px' }}>
            {categoryStore.content?.trades && categoryStore.content?.trades.length <= 0 ? (
              <EmptyTextSwap>
                <TextStyle color="primary_light" type="b_18">
                  해당 작품이 없습니다.
                </TextStyle>
              </EmptyTextSwap>
            ) : (
              <SwiperWrap>
                <Swiper
                  slidesPerView={4}
                  spaceBetween={15}
                  freeMode={true}
                  speed={300}
                  modules={[FreeMode]}
                  className="mySwiper"
                >
                  {categoryStore.content?.trades.map((d, i) => (
                    <SwiperSlide key={i}>
                      <ProductCard
                        page={'HOME'}
                        title={d.name}
                        artist={d.artist}
                        img={d.imageUri}
                        routerLink={`/market/${d.id}`}
                        isFavorite={d.favorite}
                      />
                    </SwiperSlide>
                  ))}
                  <SwiperSlide />
                  <SwiperSlide id="dummy-slide" />
                </Swiper>
              </SwiperWrap>
            )}
          </div>
          <DivideLineBold />
          <CustomSpacer spacing="24px" />
          <CategoryTitle href={'/market'}>판매 예정 작품</CategoryTitle>
          <div style={{ height: '219px' }}>
            {categoryStore.content?.toBeReleases && categoryStore.content?.toBeReleases.length <= 0 ? (
              <EmptyTextSwap>
                <TextStyle color="primary_light" type="b_18">
                  해당 작품이 없습니다.
                </TextStyle>
              </EmptyTextSwap>
            ) : (
              <SwiperWrap>
                <Swiper
                  slidesPerView={4}
                  spaceBetween={15}
                  freeMode={true}
                  speed={300}
                  modules={[FreeMode]}
                  className="mySwiper"
                >
                  {categoryStore.content?.toBeReleases.map((d, i) => (
                    <SwiperSlide key={i}>
                      <ProductCard
                        page={'HOME'}
                        title={d.name}
                        artist={d.artist}
                        img={d.imageUri}
                        routerLink={`/market/${d.id}`}
                        isFavorite={d.favorite}
                      />
                    </SwiperSlide>
                  ))}
                  <SwiperSlide />
                  <SwiperSlide id="dummy-slide" />
                </Swiper>
              </SwiperWrap>
            )}
          </div>
          <DivideLineBold />
          <CustomSpacer spacing="24px" />
          <CategoryTitle href={'/sellHistory'}>이전 매각 히스토리</CategoryTitle>
          <HistoryContainer>
            <HistoryWrap>
              <div className="icon_container">
                <IonIcon color="medium" icon={cashSharp}></IonIcon>
              </div>
              <div className="content_container">
                <TextStyle type={'r_12'} color={'primary_light'}>
                  수익률
                </TextStyle>
                <TextStyle type={'r_16'}>{getRevenueRate()}</TextStyle>
              </div>
            </HistoryWrap>
            <HistoryWrap>
              <div className="icon_container">
                <IonIcon color="medium" icon={timeSharp}></IonIcon>
              </div>
              <div className="content_container">
                <TextStyle type={'r_12'} color={'primary_light'}>
                  보유기간
                </TextStyle>
                <TextStyle type={'r_16'}>
                  {mainStore.content?.sellHistory?.retentionDate
                    ? `${mainStore.content?.sellHistory?.retentionDate}일`
                    : '-'}
                </TextStyle>
              </div>
            </HistoryWrap>
          </HistoryContainer>
          <CustomSpacer spacing={'20px'} />
        </DetailContent>
      </IonContent>
    </IonPage>
  )
})

const HistoryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  margin: 0 20px 30px 20px;
`

const HistoryWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .icon_container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20%;
    ion-icon {
      font-size: 20px;
    }
  }
  .content_container {
    display: flex;
    flex-direction: column;
    width: 80%;
    line-height: 17px;
  }
`

const SwiperWrap = styled.div`
  width: 700px;
  margin: 0 0 24px 20px;
  .swiper-container {
    overflow-x: hidden;
  }
  @media (min-width: 540px) and (max-width: 700px) {
    #dummy-slide {
      display: none;
    }
  }
`

const BannersContainer = styled.div`
  position: relative;
  img {
    width: 100%;
    height: 300px;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
  .info {
    font-size: 30px;
    font-weight: bold;
    position: absolute;
    bottom: 20px;
    left: 20px;
    color: #ffffff;
    .artist {
      display: block;
    }
    .name {
      font-size: 20px;
    }
  }
`

const SSwiper = styled(Swiper)`
  padding-bottom: 25px;
  .swiper-pagination {
    position: absolute;
    bottom: 7px;
  }
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background-color: var(--ion-color-primary_dark);
  }
  .swiper-button-prev {
    background: url(/img/icon/chevron-back-outline.svg) no-repeat;
    background-size: 80% auto;
    background-position: 30%, center;
    width: 30px;
    height: 30px;
    background-color: #f5f5f5;
    border-radius: 100%;
  }
  .swiper-button-next {
    background: url(/img/icon/chevron-forward-outline.svg) no-repeat;
    background-size: 80% auto;
    background-position: 70%, center;
    width: 30px;
    height: 30px;
    background-color: #f5f5f5;
    border-radius: 100%;
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    display: none;
  }
`

const EmptyTextSwap = styled.div`
  height: 219px;
  display: flex;
  justify-content: center;
  align-items: center;
`
